import outletIcon from './icon.svg'
import styles from './DropdownOutlet.css'
import tickedOutlet from './ticked-outlet.svg'
import {Dropdown, Button, MenuItem} from 'react-bootstrap'

class Toggle extends React.Component {
  render () {
    let {outletName, withCaret} = this.props
    return (<div className={styles.dropdown}>
      <Button onClick={this._onClick} bsClass={`btn btn-default ${styles['button-toggle']}`}>
        <div className={styles['outlet-name-wrapper']}>
          <img alt='Outlet icon' className={styles['outlet-icon']} src={outletIcon} />
          {outletName}
        </div>
        {withCaret && <span className='caret' />}
      </Button>
    </div>)
  }

  _onClick = (e) => {
    e.preventDefault()
    this.props.onClick(e)
  }
}

class DropdownOutlet extends React.Component {
  render () {
    let {outlets, allOutletOption, input} = this.props
    let {value} = input

    let allOutlet = {
      id: outlets.map((outlet) => (outlet.id)),
      name: 'All Outlets'
    }

    let loadingOutlet = {
      id: [],
      name: 'Loading...'
    }

    let activeOutlet = {id: [], name: ''}
    if (value.length > 1) {
      activeOutlet = allOutlet
    } else if (value.length === 1) {
      outlets.forEach(outlet => {
        if (outlet.id === value[0] && value.length === 1) {
          activeOutlet = {id: [outlet.id], name: outlet.name}
        }
      })
    } else {
      activeOutlet = loadingOutlet
    }

    if (outlets.length > 1) {
      return (<Dropdown id='dropdown-custom-1'>
        <Toggle
          outletName={activeOutlet.name}
          bsRole='toggle'
          onClick={this._onClickToggle}
          withCaret={outlets.length > 1}
        />
        <Dropdown.Menu className={styles.menu} bsRole='menu'>
          {allOutletOption && outlets.length > 1 &&
          <MenuItem
            onSelect={this._onSelect} eventKey={allOutlet.id}
            className={styles['menu-item']}
          >
            {/* <a className={styles['menu-item']}> */}
            <span>
              {activeOutlet.id.length > 1 &&
              <img alt='Ticked outlet' className={styles['list-outlet-selected-icon']} src={tickedOutlet} />
              }
            </span>
            <span className={styles['list-outlet-name']}>{allOutlet.name}</span>
            {/* </a> */}
          </MenuItem>
          }
          {outlets.map((outlet, idx) => {
            let outletIds = [outlet.id]
            return (
              <MenuItem onSelect={this._onSelect} eventKey={outletIds} className={styles['menu-item']}>
                {outlet.id === activeOutlet.id[0] && activeOutlet.id.length === 1 && <span>
                  <img alt='Ticked outlet' className={styles['list-outlet-selected-icon']} src={tickedOutlet} />
                </span>}
                <span className={styles['list-outlet-name']}>{outlet.name}</span>
              </MenuItem>)
          })}
        </Dropdown.Menu>
      </Dropdown>)
    } else {
      return (<Button bsClass={`btn btn-default ${styles['button-toggle']}`} disabled>
        <div className={styles['outlet-name-wrapper']}>
          <img alt='Outlet icon' className={styles['outlet-icon']} src={outletIcon} />
          {activeOutlet.name}
        </div>
      </Button>)
    }
  }

  _onSelect = (outletIds) => {
    this.props.onChangeOutletIds(outletIds)
  }

  _onClickToggle = () => {
  }
}

DropdownOutlet.propTypes = {
  outlets: React.PropTypes.array,
  name: React.PropTypes.string,
  allOutletOption: React.PropTypes.bool
}

export default (DropdownOutlet)



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownOutlet/DropdownOutlet.js